var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-list-table',{attrs:{"title":_vm.title,"data-service":_vm.dataService,"headers":_vm.headers,"create-route-name":_vm.createRouteName,"edit-route-name":_vm.editRouteName,"allow-delete":"","show-status-column":false}})}
var staticRenderFns = []

export { render, staticRenderFns }